//      
import React, {useEffect, useRef, useState, useSyncExternalStore} from "react";
import {Outlet, Route, Router, Routes} from "react-router";
import StartPageContainer from "../container/StartPageContainer";
import Loading from "./Loading";
import "./App.scss";
import "../assets/styling/css/oem.scss";
import {customHistory} from "../helper/history";
import ProductPageContainer from "../container/ProductPageContainer";
import NavigationBarContainer from "../container/NavigationBarContainer";
import CartContainer from "../container/CartContainer";
import FilterContainer from "../container/FilterContainer";
import SearchContainer from "../container/SearchContainer";
import SearchPageContainer from "../container/SearchPageContainer";
import ProductListPageContainer from "../container/ProductListPageContainer";
import {setTextColor} from "../helper/setTextColor";

                 
                         
                 
               
                           
 

const ShopLayout = () => <>
	<NavigationBarContainer/>
	<div className="content">
		<FilterContainer/>
		<Outlet/>
		<CartContainer/>
		<SearchContainer/>
	</div>
</>;

const getLocation = () => customHistory.location;

const App = (props          ) => {
	const {getProducts, isIdle} = props;
	const location = useSyncExternalStore(customHistory.listen, getLocation);

	const colourRef = useRef(null);
	const [backgroundColor, setBackgroundColor] = useState("");
	useEffect(() => {
		getProducts();
	}, [getProducts]);

	useEffect(() => {
		if (colourRef) {
			// get primary color as rgb
			setBackgroundColor(window.getComputedStyle(colourRef.current).backgroundColor);
			setTextColor(backgroundColor);
		}
	}, [colourRef, backgroundColor]);

	const renderApp = () => {
		return <div className="sl-app" id={"sl-content-root"}>
			<div id="colorPicker" ref={colourRef}></div>
			<Router location={location} navigator={customHistory}>
				{isIdle
					? <Routes>
						<Route path="/" element={<StartPageContainer/>}/>
						<Route element={<ShopLayout/>}>
							<Route path="/product/:productId" element={<ProductPageContainer/>}/>
							<Route path="/category/:categoryKey" element={<ProductListPageContainer/>}/>
							<Route path="/search/:fuzzy" element={<SearchPageContainer/>}/>
							<Route path="*" element={null}/>
						</Route>
					</Routes>
					: <Loading/>
				}
			</Router>
		</div>;
	};

	return renderApp();
};

export default App;
